/* eslint no-useless-escape: "off" */

import _ from 'lodash';

class validateRegex {
  constructor() {
    /* eslint-disable no-irregular-whitespace */
    this.pattern = {
      email: /^([a-zA-Z0-9])+([\.\+a-zA-Z0-9_-])*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i,
      zip: /^\d{3}\-\d{4}$|^\d{7}$/,
      int: /^([0-9]+)(\.\d+)?$/, // この int は命名が float の間違いと思われるので非推奨。numberNoSignを使ってください。
      integer: /^[+/-]?[0-9]+$/,
      number: /^[+/-]?[0-9]+(\.\d+)?$/,
      floatStrict: /^[+/-]?[0-9]+\.\d+$/,
      integerNoSign: /^[0-9]+$/,
      numberNoSign: /^[0-9]+(\.\d+)?$/,
      floatStrictNoSign: /^[0-9]+\.\d+$/,
      pwd: /^[A-Za-z0-9]+$/,
      pwd32: /^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,32}$/,
      pwdPWD32: /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[a-zA-Z\d]{8,32}$/, // 大文字許可
      //"pwdPWD32"		:/^(?=.*?[A-Za-z0-9])(?=.*?\d)[A-Za-z0-9\d]{8,32}$/, // 大文字許可
      'y/m/d': /([1-2]{1}[0-9]{3})(\/|-)([0-1][0-9])(\/|-)([0-3][0-9])/,
      kana: /^[ぁ-んァ-ンー　 ]+$/,
      hiragana: /^[ぁ-んゔー]+$/,
      katakana: /^[ァ-ヶー]+$/,
      intAndKatakana: /^[0-9ァ-ヶー]+$/,
      hankaku: /^[a-zA-Z0-9!-/:-@¥[-`{-~]+$/,
      hankakuIntegerSymbol: /^[0-9!-/:-@¥[-`{-~]+$/,
      zenkaku: /^[^\x01-\x7E\xA1-\xDF\uFF61-\uFF9F]+$/,
      otherThanZenkakuMarkAndNumeric: /^[a-zA-Z0-9!-/:-@¥[-`{-~一-龠々ゞヵヶぁ-んァ-ヴーｱ-ﾝ]+$/,
      // 全角記号と全角数字以外を許可(許可するものを正規表現で記載)
      // 以前のバージョンでは次のように記載されていた
      //  otherThanZenkakuMarkAndNumeric: /^[^！-／：-＠［-｀｛-～、-〜”’・ー￥０-９]+$/, // 全角記号と全角数字以外を許可
      // これは許可しないものを正規表現で記載されていたが
      // 「々」このような文字が含まれている場合誤動作するので修正された。BLDE_V2-17048
      otherThanZenkakuMarkAndEnglishAndNumericAndHankakuKatakana: /^[a-zA-Z0-9!-/:-@¥[-`{-~一-龠々ゞヵヶぁ-んァ-ンー\s。、]+$/,
      // 上記の正規表現に改行、半角・全角スペース、[、。]を許可
      alphanumericAndKatakana: /^[ァ-ヴa-zA-Z0-9ー\-]+$/, // 全角カナと半角英数字と半角ハイフンと全角長音のみを許可
      must: /.{1,}/,
      url: /^https?:\/\/[^ {3}]/i,
      //"tel" 			:/^0\d{2,3}-\d{1,4}-\d{4}$/,
      tel: /^0(?:\d[-]?\d{4}|\d{2}[-]?\d{3,4}|\d{3}[-]?\d{2}|\d{4}[-]?\d)[-]?\d{4}(?!\d)/,
      // 全角数字を含む電話番号。ハイフンは、長音記号（ー）と全角ハイフン（－）を許容
      telIncludingZenkaku: /^[0０](?:[\d０-９][-ー－]?[\d０-９]{4}|[\d０-９]{2}[-ー－]?[\d０-９]{3,4}|[\d０-９]{3}[-ー－]?[\d０-９]{2}|[\d０-９]{4}[-ー－]?[\d０-９])[-ー－]?[\d０-９]{4}$/,
      fax: /^0(?:\d[-]?\d{4}|\d{2}[-]?\d{3,4}|\d{3}[-]?\d{2}|\d{4}[-]?\d)[-]?\d{4}(?!\d)/,
      bank: /^\d{3,7}$/,
      login: /^[\-\.\_\@A-Za-z0-9]+$/,
      city_name: /[市区群町村郡]/,
      email_allow_empty: /^([a-zA-Z0-9])+([\.\+a-zA-Z0-9_-])*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$|()$/,
      total_operator: /^\d{1,20}$/,
      not_include_controlcode: /^[^\x00-\x09\x0b-\x1f\x7f-\x9f]*$/,
      company_number: /^\d{13}$/, // 法人番号13桁の半角数字
      hankakuAlphabetAndNumber: /^[A-Za-z0-9]+$/,
      hankakuAlphabetAndNumberAndHyphen: /^[A-Za-z0-9-]+$/,
      noSpace: /^[^ 　]+$/,
      lw_service_account: /^\w{5}\.serviceaccount@[\w@\.\-_]+$/, //LINE WORKSのservice_account用,
      lw_private_key_file_name: /^(.*?)\.key$/, //LINE WORKSのprivate_key_file_name用
      area: /^(札幌|函館|旭川|室蘭|苫小牧|釧路|知床|帯広|北見|青森|弘前|八戸|岩手|盛岡|平泉|宮城|仙台|秋田|山形|庄内|福島|会津|郡山|白河|いわき|水戸|土浦|つくば|宇都宮|那須|とちぎ|群馬|前橋|高崎|大宮|川口|所沢|川越|熊谷|春日部|越谷|千葉|成田|習志野|市川|船橋|袖ヶ浦|市原|野田|柏|松戸|品川|世田谷|練馬|杉並|板橋|足立|江東|葛飾|八王子|多摩|横浜|川崎|湘南|相模|山梨|富士山|新潟|長岡|上越|長野|松本|諏訪|富山|石川|金沢|福井|岐阜|飛騨|静岡|浜松|沼津|伊豆|富士山|名古屋|豊橋|三河|岡崎|豊田|尾張小牧|一宮|春日井|三重|鈴鹿|四日市|伊勢志摩|滋賀|京都|なにわ|大阪|和泉|堺|奈良|飛鳥|和歌山|神戸|姫路|鳥取|島根|出雲|岡山|倉敷|広島|福山|山口|下関|徳島|香川|高松|愛媛|高知|福岡|北九州|久留米|筑豊|佐賀|長崎|佐世保|熊本|大分|宮崎|鹿児島|奄美|沖縄)$/,
      class_number: /^[0-9]{1}[acfhklmpxyACFHKLMPXY0-9]{0,2}$/,
      hiraganaColumn: /[ehkmtyEHKMTYあいうえかきくけこさすせそたちつてとなにぬねのはひふほまみむめもやゆよらりるれろわを]{1}$/,
      integerNoSignHalfWidth: /^[0-9]+$/,
      designated_number: /^(?!0+$)\d+$/,
    };
    /* eslint-enable no-irregular-whitespace */

    this.message = {
      email: 'メールアドレスが正しくありません。',
      zip: '正しい郵便番号を入力してください。',
      postal_code: '正しい郵便番号を入力してください。',
      int: '半角数字で入力してください。',
      integerNoSign: '半角数字を入力してください。',
      pwd: '半角英数字で入力してください。',
      pwd32:
        '小文字・数字・それぞれを含む、半角英数8~32文字で入力してください。',
      pwdPWD32:
        '大文字・小文字・数字・それぞれを含む、半角英数8~32文字で入力してください。',
      'y/m/d': '日付の形式を2016/09/01で入力してください。',
      kana: 'ひらがなで入力してください。',
      hiragana: 'ひらがなで入力してください。',
      katakana: '全角カタカナで入力してください。',
      intAndKatakana: '半角数字と全角カタカナで入力してください。',
      min: '文字数が少ないです。',
      max: '文字数が多いです。',
      hankaku: '半角で入力してください。',
      hankakuIntegerSymbol: '半角数字と半角記号で入力してください。',
      hankakuAlphaNumSymbol: '半角英数字と半角記号で入力してください。',
      zenkaku: '全角で入力してください。',
      otherThanZenkakuMarkAndNumeric:
        '全角記号と全角数字以外で入力してください',
      otherThanZenkakuMarkAndEnglishAndNumericAndHankakuKatakana:
        '全角記号と全角英数字、半角カタカナ以外で入力してください',
      alphanumericAndKatakana: '全角カナと半角英数字で入力してください。',
      must: '必須です。',
      diffpwd: 'パスワードが一致していません。',
      url: '正しいURLを入力してください。',
      tel: '正しい番号を入力してください。',
      telIncludingZenkaku: '半角数字と全角数字で入力してください。',
      fax: '正しい番号を入力してください。',
      bank: '数字の桁数を確認してください。',
      login: '半角英数字で入力してください。',
      city_name: '市区群町村名を入力してください。',
      email_allow_empty: 'メールアドレスが正しくありません。',
      total_operator: '半角の数字で入力してください。',
      numberNoSign: '半角の数字で入力してください。',
      company_number: '13桁の半角数字で入力してください',
      hankakuAlphabetAndNumber: '半角英数字で入力してください。',
      hankakuAlphabetAndNumberAndHyphen:
        '半角英数字および半角ハイフン( - )のみ入力可能です。',
      noSpace: 'スペース以外で入力してください。',
      lw_service_account: '正しいService Accountを入力してください。',
      lw_private_key_file_name: '正しいprivate_keyを選択してください。',
      area: 'ナンバープレートの正しい地域名を入力してください。',
      class_number: 'ナンバープレートの正しい分類番号を入力してください。',
      hiraganaColumn: 'ナンバープレートの正しいひらがなを入力してください。',
      integerNoSignHalfWidth: '半角数字のみを入力してください。',
      designated_number: 'ナンバープレートの正しい指定番号を入力してください。',
    };
  }

  /**
   * 正規表現から this.pattern のプロパティ名を取得する
   */
  patternName(pattern) {
    const result = Object.entries(this.pattern).find(
      // eslint-disable-next-line no-unused-vars
      ([key, value]) => {
        // console.log('validateRegex.js patternName', value, pattern);
        return value.source === pattern.source;
      }
    );
    // console.log(
    //   'validateRegex.js patternName',
    //   Object.entries(this.pattern),
    //   pattern,
    //   result
    // );
    if (_.isUndefined(result)) {
      return '';
    }
    return result[0];
  }

  /**
   * 正規表現から this.message で定義されるメッセージを取得する
   */
  patternMessage(pattern) {
    const patternName = regex.patternName(pattern);
    if (patternName === '') {
      return '';
    }
    return regex.message[patternName];
  }
}
const regex = new validateRegex();
export default regex;



// WEBPACK FOOTER //
// ./src/utilities/validateRegex.js